/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The subject of an AgentPresenceEvent.
 */
export type AgentEventSubject = {
  /**
   * Universally unique identifier
   */
  agentId: string;
  /**
   * Universally unique identifier
   */
  orgId: string;
};

/** @internal */
export const AgentEventSubject$inboundSchema: z.ZodType<
  AgentEventSubject,
  z.ZodTypeDef,
  unknown
> = z.object({
  agent_id: types.string(),
  org_id: types.string(),
}).transform((v) => {
  return remap$(v, {
    "agent_id": "agentId",
    "org_id": "orgId",
  });
});

export function agentEventSubjectFromJSON(
  jsonString: string,
): SafeParseResult<AgentEventSubject, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AgentEventSubject$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AgentEventSubject' from JSON`,
  );
}
